import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';

import { abrirEdicionMasiva, descargarInventario, importarInventario } from '../../../actions/inventario';
import { buscarAreasConfiguracion, buscarOrganizadoresConfiguracion, buscarUbicacionesConfiguracion } from '../../../actions/configuracion';

import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const EdicionMasiva = () => {

    const dispatch = useDispatch();

    const { ventana_edicion_masiva } = useSelector(state => state.inventario);
    const { listado: listado_areas } = useSelector(state => state.configuracion.areas);
    const { listado: listado_organizadores } = useSelector(state => state.configuracion.organizadores);
    const { listado: listado_ubicaciones } = useSelector(state => state.configuracion.ubicaciones);

    const [statusProcesar, setStatusProcesar] = useState(false);

    const [areaData, setAreaData] = useState(null);
    const [areasFilter, setAreasFilter] = useState([]);

    const [organizadorData, setOrganizadorData] = useState(null);
    const [organizadoresFilter, setOrganizadoresFilter] = useState([]);

    const [ubicacionData, setUbicacionData] = useState(null);
    const [ubicacionesFilter, setUbicacionesFilter] = useState([]);

    const [archivoImportar, setArchivoImportar] = useState(null);

    const styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        container: (provided) => ({ ...provided }),
        valueContainer: (provided) => ({ ...provided, overflow: 'visible', marginTop: '15px' }),
        placeholder: (provided, state) => ({
            ...provided,
            position: 'absolute',
            top: state.hasValue || state.selectProps.inputValue ? -15 : '0%',
            transition: 'top 0.1s, font-size 0.1s',
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    const handleAbrir = () => {
        dispatch(buscarAreasConfiguracion());
    }

    const handleCerrar = () => {
        if (!statusProcesar) {
            dispatch(abrirEdicionMasiva(false));
        }
    }

    const handleSelectArea = (option) => {
        setAreaData(option);
        setOrganizadorData(null);
        setUbicacionData(null);
        setOrganizadoresFilter([]);
        setUbicacionesFilter([]);

        if (option?.value) {
            dispatch(buscarOrganizadoresConfiguracion(option.value));
        }
    }

    const handleSelectOrganizador = (option) => {
        setOrganizadorData(option);
        setUbicacionData(null);
        setUbicacionesFilter([]);

        if (option?.value) {
            dispatch(buscarUbicacionesConfiguracion(option.value));
        }
    }

    const handleSelectUbicacion = (option) => {
        setUbicacionData(option);
    }

    const handleDescargar = async () => {
        await setStatusProcesar(true);

        await dispatch(descargarInventario({
            id_area: areaData?.value || null,
            id_organizador: organizadorData?.value || null,
            id_ubicacion: ubicacionData?.value || null
        }));

        await setStatusProcesar(false);
    }

    const handleImportar = async () => {
        if (!archivoImportar) return;

        await setStatusProcesar(true);

        const formData = new FormData();
        formData.append('archivo', archivoImportar);
        formData.append('id_area', areaData?.value || '');
        formData.append('id_organizador', organizadorData?.value || '');
        formData.append('id_ubicacion', ubicacionData?.value || '');

        await dispatch(importarInventario(formData));

        await setStatusProcesar(false);

        handleCerrar();
    }

    useEffect(() => {
        let options = [];
        for (var i = 0; i < listado_areas.length; i++) {
            options.push({ value: listado_areas[i].id, label: listado_areas[i].nombre });
        }
        setAreasFilter(options);
    }, [listado_areas]);

    useEffect(() => {
        let options = [];
        for (var i = 0; i < listado_organizadores.length; i++) {
            options.push({ value: listado_organizadores[i].id, label: listado_organizadores[i].nombre });
        }
        setOrganizadoresFilter(options);
    }, [listado_organizadores]);

    useEffect(() => {
        let options = [];
        for (var i = 0; i < listado_ubicaciones.length; i++) {
            options.push({ value: listado_ubicaciones[i].id, label: listado_ubicaciones[i].nombre });
        }
        setUbicacionesFilter(options);
    }, [listado_ubicaciones]);

    return (
        <Modal show={ventana_edicion_masiva} size="md" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Edición masiva de inventario</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p className="text-muted mb-4">Descarga el Excel con los filtros deseados, edita la información y vuelve a cargarlo.</p>

                <div className="row">
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Área"
                                options={areasFilter}
                                value={areaData}
                                isClearable={true}
                                onChange={(value) => handleSelectArea(value)}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Organizador"
                                options={organizadoresFilter}
                                value={organizadorData}
                                isClearable={true}
                                isDisabled={!areaData}
                                onChange={(value) => handleSelectOrganizador(value)}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Ubicación"
                                options={ubicacionesFilter}
                                value={ubicacionData}
                                isClearable={true}
                                isDisabled={!organizadorData}
                                onChange={(value) => handleSelectUbicacion(value)}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>
                </div>

                <hr />

                <div className="row">
                    <div className="col-md-12 form-group mb-3">
                        <label className="fw-bold mb-1">Cargar Excel modificado</label>
                        <input
                            type="file"
                            className="form-control"
                            accept=".xlsx"
                            onChange={e => setArchivoImportar(e.target.files[0] || null)}
                        />
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                {
                    statusProcesar ?
                        <>
                            <button type="button" className="btn btn-secondary" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Cancelar</button>
                            <button type="button" className="btn btn-info" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Descargar Excel</button>
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Importar</button>
                        </>
                    :
                        <>
                            <button type="button" className="btn btn-secondary" onClick={() => handleCerrar()}>Cancelar</button>
                            <button type="button" className="btn btn-info" onClick={() => handleDescargar()}><i className="fas fa-download fa-sm"></i> Descargar Excel</button>
                            <button type="button" className="btn btn-success" onClick={() => handleImportar()} disabled={!archivoImportar}><i className="fas fa-upload fa-sm"></i> Importar</button>
                        </>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EdicionMasiva;
